// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.property-select__input[data-v-0b081bb8]{width:calc(100% - 34px - 34px)}`, "",{"version":3,"sources":["webpack://./src/components/Editor/Properties/PropertySelect.vue"],"names":[],"mappings":"AAGC,yCAEC,8BAAA","sourcesContent":[".property-select__input{width:calc(100% - 34px - 34px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
